import * as React from 'react';
import {CheckoutPageContainer} from './containers';

export const CheckoutPage: React.FC = () => {
    return (
        <CheckoutPageContainer />
    );
};
